
import { useState } from 'react'
import './styles/admin.css'
import UsersAdmin from '../components/admin-components/UsersAdmin'
import Herramienta1 from '../components/admin-components/NotifiTech'
import RolesAdmin from '../components/admin-components/RolesAdmin'
import NotifiAdmin from '../components/admin-components/NotifiAdmin'
import NotifiTech from '../components/admin-components/NotifiTech'
import InternalError from '../components/generales/InternalError'
import PanelUserGroups from '../components/admin-components/PanelMediciones'
import { capitalizeFirstLetter } from '../utils/utils'
import { lang } from '../components/generales/traduction'

const Admin=({server,dataGlobals,languaje,mode,pageSelected,handleShowPopup})=>{
    const [listSelected,setListSelected]=useState(1)
    const [internalError,setInternalError]=useState(false)
    const hadleChangeList=(e)=>{
        setInternalError(false)
        setListSelected(e)
    }
    window.onerror = function (message, source, lineno, colno, error) {
        console.error('Error global capturado:', message, source, lineno, colno, error);
        // Manejo de errores global, por ejemplo, mostrando una notificación
      };
    function renderAdminComponent() {
        try {
            switch (pageSelected) {
                case "admin-users":
                    return <UsersAdmin handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server} setInternalError={setInternalError} />;
                case "admin-rol":
                    return <RolesAdmin  handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
                case "noti-user":
                    return <NotifiAdmin handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
                case "noti-tec":
                    return <NotifiTech handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
                case "admin-grupos":
                    return <PanelUserGroups handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
                default:
                    return <Herramienta1 handleShowPopup={handleShowPopup} server={server} setInternalError={setInternalError}/>;
            }
        } catch (error) {
            console.error('Error rendering component:', error);
            return <div>{lang[languaje['msgErrorPagina']]}</div>;
        }
    }
    return (
        <div className="main-config">
            {(internalError)?
            <InternalError/>
            :renderAdminComponent()}
            {/* <div className='head-admin'>
                <div className='title-admin'>
                    <div className='txt-title-admin'>
                    Panel de Administrador
                    </div>
                </div>
                <div className='menu-admin'>
                     <ol className='compact-menu-list' style={{justifyContent:'start'}}>
                        <li className={listSelected===1?'list-selected':''} onClick={() =>hadleChangeList(1)}>Usuarios</li>
                        <li className={listSelected===2?'list-selected':''} onClick={() =>hadleChangeList(2)}>Roles</li>
                        <li className={listSelected===3?'list-selected':''} onClick={() =>hadleChangeList(3)}>Notificaciones</li>
                        <li className={listSelected===4?'list-selected':''} onClick={() =>hadleChangeList(4)}>Not. Tecnologia</li>
                    </ol>
                </div>
                <hr className='head-line'></hr>
            </div>
            <div className='cont-admin'>
            {(internalError)?
            <InternalError/>
            :renderAdminComponent()}
            
                
            </div> */}
        </div>
    )
}

export default Admin